import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=b9163c02&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9163c02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9163c02')) {
      api.createRecord('b9163c02', component.options)
    } else {
      api.reload('b9163c02', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=b9163c02&scoped=true&", function () {
      api.rerender('b9163c02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dKmpTAbjqL3l/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports